import { render, staticRenderFns } from "./Voice.vue?vue&type=template&id=ea936512&scoped=true"
import script from "./Voice.vue?vue&type=script&lang=ts"
export * from "./Voice.vue?vue&type=script&lang=ts"
import style0 from "./Voice.vue?vue&type=style&index=0&id=ea936512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea936512",
  null
  
)

export default component.exports